import { render } from "./PointChart.vue?vue&type=template&id=64a9a190&scoped=true"
import script from "./PointChart.vue?vue&type=script&lang=js"
export * from "./PointChart.vue?vue&type=script&lang=js"

import "./PointChart.vue?vue&type=style&index=0&id=64a9a190&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a9a190"]])

export default __exports__